<template>
  <div>お探しの URL は見つかりませんでした。</div>
</template>

<script>
export default {
  name: "NotFound"
};
</script>

<style lang="scss" scoped>
</style>